import { GetAllHeatmapsResponse, HeatmapDetail } from '@fullstory/proto/fs/services/dx-objects';
import { mockHeatmapDetail } from './util';
import { FieldSuggestResponse } from '@fullstory/proto/fs/services/alexa';

export const GET_ALL_HEATMAPS_EMPTY_RESPONSE: GetAllHeatmapsResponse = { heatmaps: [] };
export const GET_ALL_HEATMAPS_RESPONSE: GetAllHeatmapsResponse = { heatmaps: [mockHeatmapDetail] };
export const SET_HEATMAP_RESPONSE: HeatmapDetail = { ...mockHeatmapDetail };
export const FIELD_SUGGEST_RESPONSE: FieldSuggestResponse = {
  completionGroups: [
    {
      field: '__merged__',
      completions: [
        {
          text: 'AppSettingsUsers',
          score: 19755066.034772858,
        },
        { text: 'AppSettingsUsersBulkActions', score: 19313564.285367478 },
        {
          text: 'AppSettingsUsersFiltering',
          score: 19301226.501241796,
        },
        { text: 'AppSelfServeSso', score: 19247041.409222648 },
        {
          text: 'AppShowQueryParamInput',
          score: 18834117.142056163,
        },
        { text: 'AppSettingsBulkCreate', score: 16164943.461895458 },
        {
          text: 'AppScreenResolutionDimension',
          score: 15605755.674585003,
        },
        { text: 'AppSidebarUpdates', score: 9144885.471901998 },
        {
          text: 'AppSettingsMobileNetworkCapture',
          score: 9040628.213792026,
        },
        { text: 'AppShowNetworkErrorText', score: 9000014.980713695 },
      ],
    },
  ],
};
